import { BACKEND_URL } from '../config/api';

/**
 * Resolve an item's stored `image` value into a usable <img> src.
 *
 * Items store one of three things: a raw inline SVG, a full URL (S3), or a bare
 * filename served by the backend. Inline SVG is returned as a data URI rather
 * than injected as HTML - scripts inside an SVG never execute when it is loaded
 * through <img>, so a malicious item image can't run in another user's session.
 */
export function getItemImageSrc(image) {
  if (!image) {
    return null;
  }

  if (image.startsWith('<svg')) {
    return `data:image/svg+xml;utf8,${encodeURIComponent(image)}`;
  }

  if (image.startsWith('http')) {
    return image;
  }

  return `${BACKEND_URL}/images/${image}`;
}

export default getItemImageSrc;
